import React from 'react';

import Check from 'assets/images/icon/Check';
import styled from 'styled-components';

const CheckBox = (props) => {
    return (
        <Container>
            <CheckBoxWrap
                onClick={() => {
                    props.onClick();
                }}
                className={props.state ? "on" : ""}
            >
                <div>
                    <Check />
                </div>
            </CheckBoxWrap>
        </Container>
    );
};

const Container = styled.div``;

const CheckBoxWrap = styled.div`
    display: flex;
    align-items: center;
    transition: all 0.2s;
    padding-bottom: 2px;
    cursor: pointer;
    &.on {
        transition: all 0.2s;

        & > div {
            transition: all 0.2s;
            border: solid 1px #ddc160;
            background: #ddc160;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    span {
        padding-top: 2px;
        font-size: 16px;
        color: #212529;
    }
    div {
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: solid 1px rgba(51, 51, 51, 0.3);
    }
`;

export { CheckBox };
